import { render, staticRenderFns } from "./DevelopmentLoginPage.vue?vue&type=template&id=35e9cce2&scoped=true"
import script from "./DevelopmentLoginPage.vue?vue&type=script&lang=js"
export * from "./DevelopmentLoginPage.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentLoginPage.vue?vue&type=style&index=0&id=35e9cce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e9cce2",
  null
  
)

export default component.exports